module.exports = __webpack_public_path__ + "static/media/bs_badge-title.3e66b9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/bs_badge-title.png
// module id = 57
// module chunks = 0